<template>
  <div>
    <van-nav-bar @click-left="onClickLeft" :border="false">
      <span slot="left" style="font-size: 17px">
        <van-icon color="black" name="arrow-left"></van-icon>
      </span>
      <span slot="title" style="font-size: 17px;color: #505050">修改订单</span>
    </van-nav-bar>
    <div style="display: flex;background: #F6F7F8;height: calc(100vh - 56px - 15.3vw);">
      <van-sidebar v-model="category" style="height: calc(100vh - 56px - 15.3vw);background: #F6F7F8;">
        <van-sidebar-item v-for="(item, index) in categorys" @click="categoryChange3(item)" :key="item.id">
          <div slot="title">
            {{item.categoryName}}
            <div v-if="category === index" style="position: absolute; top: -1.87vw;right: 0;display: flex">
              <img src="../../../assets/img/roundTop.png" style="width: 1.87vw;height: 1.87vw">
            </div>
            <div v-if="index === category + 1" style="position: absolute; top: 0;right: 0;display: flex">
              <img src="../../../assets/img/roundBottom.png" style="width: 1.87vw;height: 1.87vw">
            </div>
          </div>
        </van-sidebar-item>
      </van-sidebar>
      <div ref="categoryAll" @scroll="scrollCategory" style="overflow-y: auto;padding-left: 3.47vw;background: white;position: relative">
        <div ref="categoryAll" @scroll="scrollCategory" style="overflow-y: auto;padding-left: 3.47vw;background: white;position: relative">
          <div :ref="'categoryItem' + index" v-for="(item, index) in babyList" :key="item.id">
            <div style="position: relative;justify-content: left;font-size: 3.73vw;margin-bottom: 3.47vw" class="centerBox">
              <div style="width: .53vw;height: 2.93vw;background: #da3939;margin-right: 1.87vw"></div>
              {{categoryName}}
            </div>
            <my-shop-list @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)" @expend="changeExpend" @plus="changeCartGoodsNum(children, 1)" @minus="changeCartGoodsNum(children, 2)" v-for="children in item.list" :key="children.id" :row="children" :source="source" style="margin: 4.8vw 0;">
            </my-shop-list>
          </div>
        </div>
        <div style="position: relative;justify-content: left;font-size: 3.73vw;margin-bottom: 3.47vw" class="centerBox">
          <div style="width: .53vw;height: 2.93vw;background: #da3939;margin-right: 1.87vw"></div>
          <span>拼箱商品</span>
        </div>
        <div :ref="'categoryItem' + index" v-for="(item, index) in pList" :key="item.id">
          <p-list @plusTwo2="addPinSecorend(arguments)" @minusTwo2="jjPinSecorend(arguments)" @expend="changeExpend" :row="item" style="margin: 4.8vw 0;">
          </p-list>
        </div>
      </div>
    </div>
    <div @click="submitOrder" style="position: fixed; bottom: 0;left: 0;height: 15.3vw;width: 100vw" class="centerBox">
      <div style="width: 80vw;height: 10vw;border-radius: 100vw;background: #da3939;color: white;margin: 0 auto" class="centerBox">
        提交订单
      </div>
    </div>
    <div style="bottom: 0;left: 0;height: 15.3vw;width: 100vw"></div>
    <search @onSearch="onSearch" :is-show-num="modifyData.isShowNum"></search>
    <shop-inquire @back="modifyData.isShowNum++" :is-show-num="modifyDataInquire.isShowNum" :row="modifyDataInquire.row"></shop-inquire>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import searchBlack from '../../../assets/img/icon/searchBlack.png'
export default {
  name: 'ShopSearch',
  data () {
    return {
      category: 0,
      source: 0,
      shopShow: false,
      icon: {
        searchBlack
      },
      modifyDataInquire: {
        isShowNum: 0,
        row: {}
      },
      pList: [],
      allPList: [],
      isScroll: true,
      categorys: [],
      babyList: [],
      buyCars: [],
      orderlist: [], // 带过来的订单list
      modifyData: {
        isShowNum: 0
      },
      bottomInfo: {
        selectQty: 0,
        selectPrice: 0
      },
      orderInfo: {}
    }
  },
  computed: {
  },
  created () {
    this.allshop()
    const list = this.$route.query.orderlist
    console.log(this.$route.query.orderlist)
    list.forEach(item => {
      this.orderlist.push({
        id: item.goodsId,
        buyQty: item.qty,
        containerLoadId: item.containerLoadId || '',
        unitPrice: item.unitPrice,
        goodsPrice: item.goodsPrice,
        miniBuyQty: item.qty,
        goodsName: item.goodsName,
        // specificationQty: item.specificationQty,
        minList: []
      })
    })
    window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
    // console.log(JSON.parse(window.localStorage.getItem('orderlist')))
    this.$toast.clear()
  },
  mounted () {
    this.orderById()
    // this.set_keepAliveList([])
  },
  watch: {
  },
  destroyed () {
    // clearInterval(this.categoryTime)
  },
  methods: {
    ...mapActions([
      'set_keepAliveList'
    ]),
    // 下拉
    changeExpend (item) {
      item.show = !item.show
    },
    // 增加附属品
    changeCartGoodsNumTwo (data) {
      const zhu = data[1]
      const ci = data[0]
      if (zhu.buyQty > 0) {
        ci.buyQty += ci.miniBuyQty
        this.orderlist.forEach(item => {
          if (item.id === zhu.id) {
            // 第二次加
            let b = 0
            if (item.minList.length > 0) {
              item.minList.forEach(item2 => {
                if (item2.id === ci.firId) {
                  item2.buyQty = ci.buyQty
                  b++
                }
              })
            }
            // 第一次加
            if (!b) {
              item.minList.push({
                id: ci.minId,
                buyQty: ci.buyQty,
                unitPrice: ci.unitPrice,
                goodsPrice: ci.price,
                goodsName: ci.goodsName
              })
              // console.log(item.minList)
            }
          }
        })
        // console.log(this.orderlist)
        window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
      } else {
        this.$toast('请选择主商品')
      }
    },
    // 减少附属品
    minusCartGoodsNumTwo (data) {
      const zhu = data[1]
      const ci = data[0]
      ci.buyQty -= ci.miniBuyQty
      this.orderlist.forEach(item => {
        if (item.id === zhu.id) {
          if (item.minList.length > 0) {
            item.minList.forEach((item2, index) => {
              if (item2.id === ci.firId) {
                item2.buyQty = ci.buyQty
                if (item2.buyQty === 0) {
                  console.log('负数品健美了')
                  item.minList.splice(index, 1)
                }
              }
            })
          }
        }
      })
      // console.log(this.orderlist)
      window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
    },
    // 增加或者减少主品
    changeCartGoodsNum (children, type) {
      if (type === 1) {
        let a = 0
        children.buyQty += children.miniBuyQty
        this.orderlist.forEach(item => {
          if (item.id === children.id) {
            item.buyQty = children.buyQty
            a++
          }
        })
        if (!a) {
          this.orderlist.push({
            id: children.id,
            buyQty: children.buyQty,
            unitPrice: children.unitPrice,
            goodsPrice: children.price,
            goodsName: children.goodsName,
            miniBuyQty: children.miniBuyQty,
            // specificationQty: children.specificationQty,
            minList: []
          })
        }
        window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
      } else if (type === 2) {
        children.buyQty -= children.miniBuyQty
        this.orderlist.forEach((item, index) => {
          if (item.id === children.id) {
            item.buyQty = children.buyQty
            if (item.buyQty === 0) {
              // console.log('健美了')
              this.orderlist.splice(index, 1)
            }
          }
        })
        window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
      }
    },
    // 加拼箱
    addPinSecorend (data) {
      console.log(data[0]) // 里面
      console.log(data[1]) // 外面
      let a = 0
      data[0].buyQty += data[0].hsgMiniBuyQty
      this.orderlist.forEach(item => {
        if (data[0].id === item.id) {
          item.buyQty = data[0].buyQty
          a++
        }
      })
      if (!a) {
        this.orderlist.push({
          id: data[0].id,
          buyQty: data[0].buyQty,
          unitPrice: data[0].unitPrice,
          goodsPrice: data[0].price,
          containerLoadId: data[1].id,
          goodsName: data[0].goodsName,
          miniBuyQty: data[0].hsgMiniBuyQty,
          // specificationQty: data[0].specificationQty,
          minList: []
        })
      }
      // console.log(this.orderlist)
    },
    // 减拼箱
    jjPinSecorend (data) {
      data[0].buyQty -= data[0].hsgMiniBuyQty
      this.orderlist.forEach((item, index) => {
        if (item.id === data[0].id) {
          item.buyQty = data[0].buyQty
          if (item.buyQty === 0) {
            // console.log('健美了')
            this.orderlist.splice(index, 1)
          }
        }
      })
      // console.log(this.orderlist)
      window.localStorage.setItem('orderlist', JSON.stringify(this.orderlist))
    },
    // 搜索
    onSearch (value) {
      // console.log(1)
      this.modifyDataInquire.isShowNum++
      this.modifyDataInquire.row = {
        title: value,
        type: 'text'
      }
    },
    // 一进来就调
    orderById () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.listOrder({
        id: this.$route.query.orderId
      })
        .then((response) => {
          this.$toast.clear()
          this.orderInfo = response.data[0]
          this.selectCategory2()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    allshop () {
      this.$request.shop.listCategoryContainerLoadById({ containerLoadClassify: '' })
        .then(res => {
          res.data.forEach(item => {
            this.$set(item, 'show', false)
            if (item.shopGoodsVOList) {
              item.shopGoodsVOList.forEach(item3 => {
                this.$set(item3, 'miniTrue', item.miniBuyQty)
                this.$set(item3, 'miniGoodsName', item.containerLoadName)
              })
            }
          })
          this.allPList = res.data
        })
    },
    // 提交订单
    submitOrder () {
      // 校验
      console.log(this.orderlist)
      // 主list
      const Zplist = []
      // 拼箱list
      const Pxlist = []
      if (this.orderlist.length > 0) {
        this.orderlist.forEach(item => {
          if (item.containerLoadId) {
            Pxlist.push(item)
          } else {
            Zplist.push(item)
          }
        })
      }
      console.log(Zplist)
      console.log(Pxlist)
      // 主品校验
      // let a = 1
      // if (Zplist.length > 0) {
      //   let max = Zplist[0].miniBuyQty
      //   for (let i = 0; i < Zplist.length - 1; i++) {
      //     max = max < Zplist[i + 1].miniBuyQty ? Zplist[i + 1].miniBuyQty : max
      //   }
      //   let totol = 0
      //   Zplist.forEach(item => {
      //     totol += Number(item.buyQty)
      //   })
      //   console.log(max, '最小购买量')
      //   console.log(totol, '总数')
      //   if (totol % max === 0) {
      //     console.log('主品整除')
      //   } else {
      //     this.$toast('购买数必须大于件数')
      //     console.log('主品不整除')
      //     a--
      //   }
      // }
      // 拼箱校验
      let b = 1
      if (Pxlist.length > 0) {
        let index = Pxlist.length - 1
        let numQty = 0
        for (let i = 0; i < Pxlist.length; i++) {
          const trues = Pxlist[index].containerLoadId
          if (Pxlist[i].containerLoadId === trues) {
            numQty += Pxlist[i].buyQty
          }
          if (i === Pxlist.length - 1) {
            console.log(this.pList)
            console.log(Pxlist)
            const c = this.allPList.find(item => (Number(item.id) === Number(Pxlist[i].containerLoadId))).miniBuyQty
            const d = this.allPList.find(item => (Number(item.id) === Number(Pxlist[i].containerLoadId))).containerLoadName
            console.log(numQty)
            console.log(c)
            if (numQty % c === 0) {
              console.log('拼箱整除')
            } else {
              this.$toast(d + '未达到整箱')
              console.log('拼箱不整除')
              b--
            }
            numQty = 0
            index--
          }
        }
      }
      if (b > 0) {
        this.orderItemList = []
        this.orderlist.forEach(item => {
          this.orderItemList.push({
            orderNo: this.orderInfo.orderNo, // buzhidao
            goodsId: item.id,
            goodsName: item.goodsName,
            containerLoadId: item.containerLoadId || '',
            miniBuyQty: item.miniBuyQty,
            goodsPrice: item.goodsPrice,
            qty: item.buyQty
          })
        })
        // let len = this.orderItemList.length
        // for (let i = 0; i < len; i++) {
        //   for (let j = i + 1; j < len; j++) {
        //     if (this.orderItemList[i].goodsName === this.orderItemList[j].goodsName) {
        //       this.orderItemList[i].qty += this.orderItemList[j].qty
        //       this.orderItemList.splice(j, 1) // arr删除重复元素
        //       len--
        //       j-- // 每删除一个数j的值就减1
        //     }
        //   }
        // }
        if (this.orderItemList.length > 0) {
          this.compolete()
        } else {
          this.$toast('请选择商品')
        }
      }
    },
    // 最终结算
    orderFinally () {
      this.$toast.loading({
        duration: 0
      })
      console.log(this.orderItemList)
      this.$request.orderShop.updateOrderItemByShz({
        orderId: this.orderInfo.id,
        orderPrice: this.bottomInfo.selectPrice * 100,
        hsbcShopOrderItemList: this.orderItemList
      })
        .then((response) => {
          this.$toast.clear()
          this.$toast(response.msg)
          if (response.code === '200') {
            setTimeout(() => {
              this.$router.go(-1)
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 计算多少钱
    compolete () {
      // console.log(this.orderlist)
      this.bottomInfo.selectPrice = 0
      this.bottomInfo.selectQty = 0
      this.orderlist.forEach(item => {
        this.bottomInfo.selectPrice += item.unitPrice * item.buyQty / 100
        // if (item.minList.length > 0) {
        //   item.minList.forEach(item2 => {
        //     this.bottomInfo.selectPrice += item2.unitPrice * item2.buyQty / 100
        //   })
        // }
      })
      // console.log(this.bottomInfo.selectPrice)
      this.orderFinally()
    },
    // 查分类
    selectCategory2 () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.pageCategory2()
        .then((response) => {
          this.$toast.clear()
          this.categorys = response.data
          this.trueItem = response.data[0]
          if (this.$route.query.index) {
            this.category = Number(this.$route.query.index)
            this.categoryChange3(this.categorys[this.category])
          } else {
            this.categoryChange3(this.trueItem)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 每一个分类list
    categoryChange3 (item) {
      const list = JSON.parse(window.localStorage.getItem('orderlist'))
      this.$toast.loading({
        duration: 0
      })
      this.trueItem = item
      this.$route.query.index = ''
      this.categoryName = item.categoryName
      this.$request.shop.listOrder2({ id: item.id })
        .then((response) => {
          this.$toast.clear()
          response.data.forEach(item => {
            item.list.forEach(item2 => {
              this.$set(item2, 'show', false)
              list.forEach(item3 => {
                if (item3.id === item2.id) {
                  item2.buyQty = item3.buyQty
                  // if (item2.minGoodsList) {
                  //   if (item2.minGoodsList.length > 0 && item3.minList.length > 0) {
                  //     item2.minGoodsList.forEach(zi => {
                  //       item3.minList.forEach(zi2 => {
                  //         if (zi.firId === zi2.id) {
                  //           zi.buyQty = zi2.buyQty
                  //         }
                  //       })
                  //     })
                  //   }
                  // }
                }
              })
            })
          })
          this.babyList = response.data
          this.$request.shop.listCategoryContainerLoadById({ containerLoadClassify: item.id })
            .then(res => {
              res.data.forEach(item => {
                this.$set(item, 'show', false)
                if (item.shopGoodsVOList) {
                  item.shopGoodsVOList.forEach(item3 => {
                    this.$set(item3, 'miniTrue', item.miniBuyQty)
                    this.$set(item3, 'miniGoodsName', item.containerLoadName)
                    // console.log(item3)
                    list.forEach(order => {
                      if (item3.id === order.id) {
                        item3.buyQty = order.buyQty
                        item.show = true
                      }
                    })
                  })
                }
              })
              this.pList = res.data
            })
        })
    },
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },
    // 滚轮啥的
    scrollCategory () {
      if (this.isScroll) {
        for (let i = this.categorys.length - 1; i >= 0; i--) {
          if (this.categorys[i + 1] && this.$refs.categoryAll.scrollTop < this.categorys[i + 1].top && this.$refs.categoryAll.scrollTop > this.categorys[i].top) {
            this.category = i
            return
          } else if (!this.categorys[i + 1] && this.$refs.categoryAll.scrollTop > this.categorys[i].top) {
            this.category = i
            return
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
